/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
export { SortInstruction } from './SortInstruction.js'
export type { SortInstructionProps } from './SortInstruction.types.js'
